import AtMentionIcon from '../../../assets/svg-fc/AtMentionIcon';
import './mentionBadge.scss';

const MentionBadge = () => (
  <span className="sendbirdMentionBadge" aria-label="Unread mention">
    <AtMentionIcon width={24} height={24} />
  </span>
);

export default MentionBadge;
